// Native details stay readable without JavaScript; enhance only responsive state.
class TLFooter extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.media = matchMedia('(min-width: 900px)');
    this.sync = () => {
      for (const detail of this.querySelectorAll('.tl-footer-group')) {
        detail.open = this.media.matches;
        detail.querySelector('summary').tabIndex = this.media.matches ? -1 : 0;
      }
    };
    this.sync();
    this.media.addEventListener('change', this.sync, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = undefined; }
}
if (!customElements.get('tl-footer')) customElements.define('tl-footer', TLFooter);
